import React from "react";
import { generalStore } from "../../stores/GeneralStore";

export const useHideNavigation = () => {
    React.useEffect(() => {
        generalStore._hideNavigation++;

        return function () {
            generalStore._hideNavigation--;
        };
    }, []);
};
